module.exports = __webpack_public_path__ + "img/001.3cb716cc.jpg";